import {
  TRANSACTIONS_LOADING,
  TRANSACTIONS_ERROR,

  TRANSACTIONS_GET_CURRENCIES,
  TRANSACTIONS_GET_STATUSES,
  TRANSACTIONS_GET_TYPES,

  TRANSACTIONS_GET_LIST,
  TRANSACTIONS_GET_FILTERS,
} from "actions/transaction/constants";

const initialState = {
  loading: false,
  errors: [],

  currencies: [],
  statuses: [],
  types: [],

  transactionList: {},
  transactionFilters: [],
  transactionSingle: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TRANSACTIONS_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case TRANSACTIONS_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case TRANSACTIONS_GET_CURRENCIES:
      return {
        ...state,
        loading: false,
        currencies: action.payload,
      };
    case TRANSACTIONS_GET_STATUSES:
      return {
        ...state,
        loading: false,
        statuses: action.payload,
      };
    case TRANSACTIONS_GET_TYPES:
      return {
        ...state,
        loading: false,
        types: action.payload,
      };
    case TRANSACTIONS_GET_LIST:
      return {
        ...state,
        errors: [],
        loading: false,
        transactionList: action.payload,
      };
    case TRANSACTIONS_GET_FILTERS:
      return {
        ...state,
        errors: [],
        loading: false,
        transactionFilters: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/transactionReducer.js